import React from 'react';

import PackageReception from 'components/PackageReception';

const WorkshopPackages: React.FunctionComponent = () => {
  return <PackageReception />;
};

export default WorkshopPackages;
